import React from 'react';
import SalesAnalysisDashboard from './components/SalesAnalysisDashboard';

function App() {
  // You can change this value based on your environment
  // For example, in a production build you might use process.env.REACT_APP_API_URL
  const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://aiassistantretail.argevim.com.tr/api';

  return (
    <div className="App">
      <SalesAnalysisDashboard apiBaseUrl={apiBaseUrl} />
    </div>
  );
}

export default App;